import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Card, Spin } from 'antd';
import type { SpinProps } from 'antd';

import styles from './SuspenseFallback.module.css';

/**
 * Suspense 폴백으로 사용되는 로딩 카드 컴포넌트
 *
 * @description
 * React Suspense의 fallback prop으로 사용하기 위한 공통 로딩 컴포넌트입니다.
 * Card 형태로 로딩 스피너를 표시하며, 부모 컴포넌트의 높이에 맞춰 렌더링됩니다.
 *
 * @example
 * ```tsx
 * <Suspense fallback={<SuspenseFallback />}>
 *   <AsyncComponent />
 * </Suspense>
 * ```
 */

export type SuspenseFallbackProps = {
  spinSize?: SpinProps['size'] | number;
  className?: string;
};

const SPIN_SIZE_MAP = {
  small: 24,
  default: 32,
  large: 40,
} as const;

export const SuspenseFallback: React.FC<SuspenseFallbackProps> = ({ spinSize = 'large', className }) => {
  const size = typeof spinSize === 'number' ? spinSize : SPIN_SIZE_MAP[spinSize];

  return (
    <Card className={`${styles.fallbackCard} ${className || ''}`}>
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: size }} spin className={styles.spinnerIcon} />}
        className={styles.spinner}
      />
    </Card>
  );
};
